import React from 'react'
import styled from 'styled-components'
import ActionButton from '../ActionButton/ActionButton'
import PropTypes from 'prop-types'
import TabButton from './TabButton'
import {_L, useLocaleState} from '../../context/LocaleContext'
import {MEETING_SPACE, WORKSPACE, SERVICE_SEQUENCE} from '../../constants/const'

const TabButtons = ({
  showHome,
  onHomeClick,
  onTabButtonClick,
  availableActions
}) => {
  const localeState = useLocaleState()

  const {meetingspace, workingspace, createrequest} = availableActions

  return (
    <Container>
      {showHome && (
        <StyledActionButton
          onClick={onHomeClick}
          icon="HOME"
          backgroundColor="#ffffff"
          data-testid="tab-home-button"
        />
      )}
      {meetingspace && (
        <TabButton
          onClick={onTabButtonClick}
          dataTestid="tab-meeting-button"
          label={_L({key: 'BOOK A MEETING SPACE', localeState})}
          action={MEETING_SPACE}
        />
      )}
      {workingspace && (
        <TabButton
          onClick={onTabButtonClick}
          dataTestid="tab-workspace-button"
          label={_L({key: 'BOOK A WORKING SPACE', localeState})}
          action={WORKSPACE}
        />
      )}
      {createrequest && (
        <TabButton
          onClick={onTabButtonClick}
          dataTestid="tab-service-button"
          label={_L({key: 'CREATE A REQUEST', localeState})}
          action={SERVICE_SEQUENCE}
        />
      )}
    </Container>
  )
}

TabButtons.propTypes = {
  onTabButtonClick: PropTypes.func.isRequired,
  onHomeClick: PropTypes.func.isRequired,
  showHome: PropTypes.bool.isRequired
}

TabButtons.defaultProps = {
  showHome: false
}
export default TabButtons

const Container = styled.div`
  height: 80px;
  background: transparent;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
`
const StyledActionButton = styled(ActionButton)`
  box-shadow: 0 10px 40px 0 rgba(0, 0, 0, 0.05);
  margin: 10px;
  @media (max-width: 1024px) {
    height: 55px;
    width: 55px;
  }
`
